import { useParams } from '@tanstack/react-router'
import { SopEditor } from '@/shell/services/sop-registry'

/** /sop-manage/$sopId/edit — the SOP template editor. */
export function SopEditorPage() {
  const { sopId } = useParams({ strict: false }) as { sopId?: string }
  if (!sopId) return null
  return <SopEditor key={sopId} sopId={sopId} viewTo={`/sop-manage/${sopId}`} />
}
